"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
const labels = exports.labels = {
  he: {
    close: 'סגירה',
    confirm: 'אישור',
    change_school: 'החלף בית ספר',
    hello_user_name: 'היי {X},',
    good_to_have_you: 'איזה כיף שבאת.',
    message: 'לא מופיע אצלנו שיוך שלך לבית ספר.',
    now_what: 'מה עושים?',
    go_to: 'פונים ל',
    tech_support: 'מוקד התמיכה של מטח',
    use_as_guest: 'בינתיים, עד שזה יסתדר, ניתן להשתמש באתר כאורח.'
  },
  ar: {
    close: 'إغلاق',
    confirm: 'موافقة',
    change_school: 'החלף בית ספר',
    hello_user_name: 'مرحبًا {X},',
    good_to_have_you: 'سعدنا بحضورك.',
    message: 'لا يظهر لدينا أنك تنتمي/ن إلى مدرسة.',
    now_what: 'ماذا نفعل؟',
    go_to: 'نتوجّه إلى ',
    tech_support: 'مركز الدعم التابع لمطاح',
    use_as_guest: 'حتّى تتمّ تسوية الأمور، يمكن استخدام الموقع كزائر.'
  },
  en: {
    close: 'Close',
    confirm: 'OK',
    change_school: 'החלף בית ספר',
    hello_user_name: 'Hi {X},',
    good_to_have_you: 'It’s so good to see you.',
    message: 'It seems that you have not been assigned to a registered school.',
    now_what: 'So what do we do?',
    go_to: 'Please contact ',
    tech_support: "CET's technical support center",
    use_as_guest: 'In the meantime, until the issue is resolved, you may continue as a guest.'
  }
};